import React from "react";
import styles from "./Typography.module.scss";

export function Typography() {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>Typography</div>
        </div>

        {/* Headlines */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Headlines</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Montserrat
line-height: 120%
letter-spacing: -2%
weight: Black (5XL-L)
weight: Extra Bold (M-2XS)`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <div className="headline-5xl">Pulse Text</div>
                <p className={styles.description}>Headline 5XL-Black / 72px</p>
                <code className={styles.classLabel}>headline-5xl</code>
              </div>
              <div className={styles.example}>
                <div className="headline-4xl">Pulse Text</div>
                <p className={styles.description}>Headline 4XL-Black / 64px</p>
                <code className={styles.classLabel}>headline-4xl</code>
              </div>
              <div className={styles.example}>
                <div className="headline-3xl">Pulse Text</div>
                <p className={styles.description}>Headline 3XL-Black / 56px</p>
                <code className={styles.classLabel}>headline-3xl</code>
              </div>
              <div className={styles.example}>
                <div className="headline-2xl">Pulse Text</div>
                <p className={styles.description}>Headline 2XL-Black / 48px</p>
                <code className={styles.classLabel}>headline-2xl</code>
              </div>
              <div className={styles.example}>
                <div className="headline-xl">Pulse Text</div>
                <p className={styles.description}>Headline XL-Black / 40px</p>
                <code className={styles.classLabel}>headline-xl</code>
              </div>
              <div className={styles.example}>
                <div className="headline-l">Pulse Text</div>
                <p className={styles.description}>Headline L-Black / 32px</p>
                <code className={styles.classLabel}>headline-l</code>
              </div>
              <div className={styles.example}>
                <div className="headline-m">Pulse Text</div>
                <p className={styles.description}>
                  Headline M-Extra-Bold / 24px
                </p>
                <code className={styles.classLabel}>headline-m</code>
              </div>
              <div className={styles.example}>
                <div className="headline-s">Pulse Text</div>
                <p className={styles.description}>
                  Headline S-Extra-Bold / 20px
                </p>
                <code className={styles.classLabel}>headline-s</code>
              </div>
              <div className={styles.example}>
                <div className="headline-xs">Pulse Text</div>
                <p className={styles.description}>
                  Headline XS-Extra-Bold / 16px
                </p>
                <code className={styles.classLabel}>headline-xs</code>
              </div>
              <div className={styles.example}>
                <div className="headline-2xs">Pulse Text</div>
                <p className={styles.description}>
                  Headline 2XS-Extra-Bold / 14px
                </p>
                <code className={styles.classLabel}>headline-2xs</code>
              </div>
            </div>
          </div>
        </section>

        {/* Sub-Headlines */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Sub-Headlines</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Montserrat
line-height: 120%
letter-spacing: -2%
weight: Medium (except L: Extra Bold)`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <div className="sub-headline-5xl">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline 5XL-Medium / 72px
                </p>
                <code className={styles.classLabel}>sub-headline-5xl</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-4xl">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline 4XL-Medium / 64px
                </p>
                <code className={styles.classLabel}>sub-headline-4xl</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-3xl">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline 3XL-Medium / 56px
                </p>
                <code className={styles.classLabel}>sub-headline-3xl</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-2xl">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline 2XL-Medium / 48px
                </p>
                <code className={styles.classLabel}>sub-headline-2xl</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-xl">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline XL-Medium / 40px
                </p>
                <code className={styles.classLabel}>sub-headline-xl</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-l">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline L-Medium / 32px
                </p>
                <code className={styles.classLabel}>sub-headline-l</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-m">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline M-Medium / 24px
                </p>
                <code className={styles.classLabel}>sub-headline-m</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-s">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline S-Medium / 20px
                </p>
                <code className={styles.classLabel}>sub-headline-s</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-xs">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline XS-Medium / 16px
                </p>
                <code className={styles.classLabel}>sub-headline-xs</code>
              </div>
              <div className={styles.example}>
                <div className="sub-headline-2xs">Pulse Text</div>
                <p className={styles.description}>
                  Sub-Headline 2XS-Medium / 14px
                </p>
                <code className={styles.classLabel}>sub-headline-2xs</code>
              </div>
            </div>
          </div>
        </section>

        {/* Body */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Body</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
line-height: 140%
letter-spacing: 0%
weights: Regular, Medium, Bold`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <div className="body-2xl body-regular">Pulse Text</div>
                <p className={styles.description}>Body 2XL-Regular / 24px</p>
                <code className={styles.classLabel}>
                  .body-2xl.body-regular
                </code>
              </div>
              <div className={styles.example}>
                <div className="body-2xl body-medium">Pulse Text</div>
                <p className={styles.description}>Body 2XL-Medium / 24px</p>
                <code className={styles.classLabel}>body-2xl.body-medium</code>
              </div>
              <div className={styles.example}>
                <div className="body-2xl body-bold">Pulse Text</div>
                <p className={styles.description}>Body 2XL-Bold / 24px</p>
                <code className={styles.classLabel}>body-2xl.body-bold</code>
              </div>
              <div className={styles.example}>
                <div className="body-xl body-regular">Pulse Text</div>
                <p className={styles.description}>Body XL-Regular / 20px</p>
                <code className={styles.classLabel}>body-xl.body-regular</code>
              </div>
              <div className={styles.example}>
                <div className="body-xl body-medium">Pulse Text</div>
                <p className={styles.description}>Body XL-Medium / 20px</p>
                <code className={styles.classLabel}>body-xl.body-medium</code>
              </div>
              <div className={styles.example}>
                <div className="body-xl body-bold">Pulse Text</div>
                <p className={styles.description}>Body XL-Bold / 20px</p>
                <code className={styles.classLabel}>body-xl.body-bold</code>
              </div>
              <div className={styles.example}>
                <div className="body-l body-regular">Pulse Text</div>
                <p className={styles.description}>Body L-Regular / 16px</p>
                <code className={styles.classLabel}>body-l.body-regular</code>
              </div>
              <div className={styles.example}>
                <div className="body-l body-medium">Pulse Text</div>
                <p className={styles.description}>Body L-Medium / 16px</p>
                <code className={styles.classLabel}>body-l.body-medium</code>
              </div>
              <div className={styles.example}>
                <div className="body-l body-bold">Pulse Text</div>
                <p className={styles.description}>Body L-Bold / 16px</p>
                <code className={styles.classLabel}>body-l.body-bold</code>
              </div>
              <div className={styles.example}>
                <div className="body-m body-regular">Pulse Text</div>
                <p className={styles.description}>Body M-Regular / 14px</p>
                <code className={styles.classLabel}>body-m.body-regular</code>
              </div>
              <div className={styles.example}>
                <div className="body-m body-medium">Pulse Text</div>
                <p className={styles.description}>Body M-Medium / 14px</p>
                <code className={styles.classLabel}>body-m.body-medium</code>
              </div>
              <div className={styles.example}>
                <div className="body-m body-bold">Pulse Text</div>
                <p className={styles.description}>Body M-Bold / 14px</p>
                <code className={styles.classLabel}>body-m.body-bold</code>
              </div>
              <div className={styles.example}>
                <div className="body-s body-regular">Pulse Text</div>
                <p className={styles.description}>Body S-Regular / 12px</p>
                <code className={styles.classLabel}>body-s.body-regular</code>
              </div>
              <div className={styles.example}>
                <div className="body-s body-medium">Pulse Text</div>
                <p className={styles.description}>Body S-Medium / 12px</p>
                <code className={styles.classLabel}>body-s.body-medium</code>
              </div>
              <div className={styles.example}>
                <div className="body-s body-bold">Pulse Text</div>
                <p className={styles.description}>Body S-Bold / 12px</p>
                <code className={styles.classLabel}>body-s.body-bold</code>
              </div>
            </div>
          </div>
        </section>

        {/* Labels */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Labels</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
line-height: 137%
letter-spacing: 3%
weight: Bold`}</code>
          </div>
          <div className={styles.grid}>
            <div className={styles.examples}>
              <div className={styles.example}>
                <div className="label-l">Pulse Text</div>
                <p className={styles.description}>Label L-Bold / 16px</p>
                <code className={styles.classLabel}>label-l</code>
              </div>
              <div className={styles.example}>
                <div className="label-m">Pulse Text</div>
                <p className={styles.description}>Label M-Bold / 12px</p>
                <code className={styles.classLabel}>label-m</code>
              </div>
              <div className={styles.example}>
                <div className="label-s">Pulse Text</div>
                <p className={styles.description}>Label S-Bold / 10px</p>
                <code className={styles.classLabel}>label-s</code>
              </div>
            </div>
          </div>
        </section>

        {/* Chips */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Chips</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
line-height: 137%
letter-spacing: 3%
weight: Medium`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <div className="chip-m">Pulse Text</div>
                <p className={styles.description}>Chip M-Medium / 12px</p>
                <code className={styles.classLabel}>chip-m</code>
              </div>
              <div className={styles.example}>
                <div className="chip-s">Pulse Text</div>
                <p className={styles.description}>Chip S-Medium / 10px</p>
                <code className={styles.classLabel}>chip-s</code>
              </div>
            </div>
          </div>
        </section>

        {/* Footnote/Legal */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Footnote/Legal</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
line-height: 140%
letter-spacing: 2%
weights: Regular, Medium, Bold`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <div className="footnote-xs footnote-regular">Pulse Text</div>
                <p className={styles.description}>
                  Footnote-Legal XS-Regular / 10px
                </p>
                <code className={styles.classLabel}>
                  .footnote-xs.footnote-regular
                </code>
              </div>
              <div className={styles.example}>
                <div className="footnote-xs footnote-medium">Pulse Text</div>
                <p className={styles.description}>
                  Footnote-Legal XS-Medium / 10px
                </p>
                <code className={styles.classLabel}>
                  .footnote-xs.footnote-medium
                </code>
              </div>
              <div className={styles.example}>
                <div className="footnote-xs footnote-bold">Pulse Text</div>
                <p className={styles.description}>
                  Footnote-Legal XS-Bold / 10px
                </p>
                <code className={styles.classLabel}>
                  .footnote-xs.footnote-bold
                </code>
              </div>
            </div>
          </div>
        </section>

        {/* Buttons */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Buttons</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
line-height: 20px
letter-spacing: 4%
weight: Bold`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <button className="button-xl">Continue</button>
                <p className={styles.description}>Button XL-Bold / 16px</p>
                <code className={styles.classLabel}>button-xl</code>
              </div>
              <div className={styles.example}>
                <button className="button-l">Continue</button>
                <p className={styles.description}>Button L-Bold / 14px</p>
                <code className={styles.classLabel}>button-l</code>
              </div>
              <div className={styles.example}>
                <button className="button-m">Continue</button>
                <p className={styles.description}>Button M-Bold / 12px</p>
                <code className={styles.classLabel}>button-m</code>
              </div>
              <div className={styles.example}>
                <button className="button-s">Continue</button>
                <p className={styles.description}>Button S-Bold / 10px</p>
                <code className={styles.classLabel}>button-s</code>
              </div>
            </div>
          </div>
        </section>

        {/* Links */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Links</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
line-height: 140%
letter-spacing: 0%
weight: Regular (Inline), Semi-Bold (Stand-Alone)`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              {/* Inline Links */}
              <div className={styles.example}>
                <a href="#" className="inline-link-2xl">
                  Continue
                </a>
                <p className={styles.description}>
                  Inline-Link 2XL-Regular / 24px
                </p>
                <code className={styles.classLabel}>inline-link-2xl</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="inline-link-xl">
                  Continue
                </a>
                <p className={styles.description}>
                  Inline-Link XL-Regular / 20px
                </p>
                <code className={styles.classLabel}>inline-link-xl</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="inline-link-l">
                  Continue
                </a>
                <p className={styles.description}>
                  Inline-Link L-Regular / 16px
                </p>
                <code className={styles.classLabel}>inline-link-l</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="inline-link-m">
                  Continue
                </a>
                <p className={styles.description}>
                  Inline-Link M-Regular / 14px
                </p>
                <code className={styles.classLabel}>inline-link-m</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="inline-link-s">
                  Continue
                </a>
                <p className={styles.description}>
                  Inline-Link S-Regular / 12px
                </p>
                <code className={styles.classLabel}>inline-link-s</code>
              </div>

              {/* Stand-Alone Links */}
              <div className={styles.example}>
                <a href="#" className="standalone-link-2xl">
                  Continue
                </a>
                <p className={styles.description}>
                  Stand-Alone-Link 2XL-Semi-Bold / 24px
                </p>
                <code className={styles.classLabel}>standalone-link-2xl</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="standalone-link-xl">
                  Continue
                </a>
                <p className={styles.description}>
                  Stand-Alone-Link XL-Semi-Bold / 20px
                </p>
                <code className={styles.classLabel}>standalone-link-xl</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="standalone-link-l">
                  Continue
                </a>
                <p className={styles.description}>
                  Stand-Alone-Link L-Semi-Bold / 16px
                </p>
                <code className={styles.classLabel}>standalone-link-l</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="standalone-link-m">
                  Continue
                </a>
                <p className={styles.description}>
                  Stand-Alone-Link M-Semi-Bold / 14px
                </p>
                <code className={styles.classLabel}>standalone-link-m</code>
              </div>
              <div className={styles.example}>
                <a href="#" className="standalone-link-s">
                  Continue
                </a>
                <p className={styles.description}>
                  Stand-Alone-Link S-Semi-Bold / 12px
                </p>
                <code className={styles.classLabel}>standalone-link-s</code>
              </div>
            </div>
          </div>
        </section>

        {/* Tabs */}
        <section className={styles.section}>
          <div className={styles.sectionTitle}>Tabs</div>
          <div className={styles.cssDetails}>
            <code className={styles.cssCode}>{`font-family: Work Sans
letter-spacing: 4%
weight: Semi Bold`}</code>
          </div>
          <div className="">
            <div className={styles.examples}>
              <div className={styles.example}>
                <button className="tab-l">Continue</button>
                <p className={styles.description}>
                  Tab L-Semi-Bold / 16px / Line Height: 24px
                </p>
                <code className={styles.classLabel}>tab-l</code>
              </div>
              <div className={styles.example}>
                <button className="tab-m">Continue</button>
                <p className={styles.description}>
                  Tab M-Semi-Bold / 14px / Line Height: 20px
                </p>
                <code className={styles.classLabel}>tab-m</code>
              </div>
              <div className={styles.example}>
                <button className="tab-s">Continue</button>
                <p className={styles.description}>
                  Tab S-Semi-Bold / 10px / Line Height: 20px
                </p>
                <code className={styles.classLabel}>tab-s</code>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
